import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, filter } from 'rxjs/operators';
import { FilterOptionType } from 'src/app/library/enums/filters/filter.enum';
import { IFilter } from 'src/app/library/interfaces/filters/filter';
import { IFilterOption } from 'src/app/library/interfaces/filters/filter-option';
import { FilterService } from 'src/app/library/services/filter/filter.service';
import { SearchApiService } from 'src/app/library/services/search/search-api.service';

@Component({
    selector: 'filter-single-select-search',
    templateUrl: './filter-single-select-search.component.html',
    styleUrls: ['./filter-single-select-search.component.scss']
})
export class FilterSingleSelectSearchComponent implements OnInit {
    @Input() filter: IFilter;

    public search = new UntypedFormControl();
    public data: any[];
    public dataTypeEnum = FilterOptionType;
    public dataLoading: boolean = false;

    constructor(
        private searchApiService: SearchApiService,
        private filterService: FilterService
    ) {}

    ngOnInit() {
        this.listeners();
    }

    public removeFilter() {
        this.filterService.removeFilter(this.filter);
        this.filterService.filterChangeEvent();
    }

    public selectOption(obj: IFilterOption) {
        let currentVal = this.filterService.filterConfig;
        let filterVal = currentVal.filters.find(
            e => e.field == this.filter.field
        );
        if (filterVal) {
            filterVal.options?.forEach(e => (e.isSelected = false));
            let optionVal = filterVal.options?.find(e => e.value == obj.value);
            if (optionVal) {
                optionVal.isSelected = true;
            } else {
                obj.isSelected = true;
                filterVal.options = [...(filterVal.options ?? []), obj];
            }
            this.filterService.filterConfig = currentVal;
            this.filterService.filterChangeEvent();
        }
    }

    public onFilterClick() {
        this.search.setValue('', { emitEvent: false });
    }

    private listeners() {
        this.search.valueChanges
            .pipe(
                debounceTime(200),
                filter(x => x)
            )
            .subscribe(async data => {
                this.dataLoading = true;
                if (this.filter.isQueryable) {
                    this.data = await this.filterService.filterQueryEvent(
                        this.filter,
                        data
                    );
                } else {
                    data = data.toLowerCase();
                    this.data = this.filter.options
                        .filter(
                            x =>
                                x.heading?.toLowerCase().includes(data) ||
                                x.subheading?.toLowerCase().includes(data)
                        )
                        .slice(0, 10);
                }

                this.dataLoading = false;
            });
    }

    get selectedOption() {
        return this.filter.options?.find(e => e.isSelected);
    }

    get isMostRecentFilter() {
        return (
            this.filterService.mostRecentFilter()?.field == this.filter.field
        );
    }

    get addedFilterLength() {
        return this.filterService.filterConfig.filters.filter(e => e.added)
            .length;
    }
}
